<div
  class="card"
  [ngClass]="isLoading ? 'skeleton-loader' : 'loaded'">
  <div class="card-body d-flex flex-column">
    <div class="card-title mb-4">
      <div class="row align-items-center">
        <div class="col-auto">
          <div
            class="icon-rounded small-icon bg-secondary text-white"
            [ngClass]="{ 'loading': isLoading }">
            <i class="iconoir-credit-card"></i>
          </div>
        </div>
        <div class="col text-secondary">
          <span [ngClass]="{ 'loading': isLoading }">All Cards</span>
        </div>
      </div>
    </div>

    <div class="card-text">
      <div class="row mb-3 align-items-center row-cols-3 g-2">
        @for (card of cardData; track card.name; let i = $index) {
          <ng-container
            [ngTemplateOutlet]="statBlock"
            [ngTemplateOutletContext]="{
              value: card.details.value,
              label: card.details.label,
              bgClass: card.details.class,
              index: i,
              name: card.name,
            }">
          </ng-container>
        }
      </div>
    </div>

    <ng-template
      #statBlock
      let-label="label"
      let-name="name"
      let-value="value"
      let-bgClass="bgClass"
      let-i="index">
      <div class="col">
        <div
          class="card-widget-block {{ bgClass }}"
          [ngClass]="{ 'loading d-block': isLoading, 'disabled': value === 0 }"
          id="statBlock{{ i }}"
          [ngbTooltip]="tooltip">
          <ng-template #tooltip>
            @if (name === CardsWidgetLabels.available) {
              Your available cards equal your total allocation of {{ currentSubscriptionCardsMax() }} cards, minus any
              active, new, invitation-pending, blocked, and removed cards.
            }
            @if (name === CardsWidgetLabels.new) {
              Cards assigned to employees but not yet activated through ID verification.
            }
            @if (name === CardsWidgetLabels.invites) {
              Cards allocated to invited employees who have not yet accepted the invitation.
            }
            @if (name === CardsWidgetLabels.removed) {
              Removed cards still appear on the cardholder's profile and count toward your available cards.
            }
            @if (name === CardsWidgetLabels.blocked) {
              Permanently or temporarily blocked cards.
            }
            @if (name === CardsWidgetLabels.active) {
              Cards that are active and in use.
            }
          </ng-template>
          <div class="amount">
            {{ value }}
          </div>
          <div class="label text-muted">
            {{ label }}
          </div>
          <div class="tooltip-icon">
            <i class="iconoir-info-circle mb-1"></i>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="text-end mt-3 mt-md-auto">
      <a
        routerLink="../cards/employee-cards"
        class="btn btn-primary btn-sm"
        [ngClass]="{ 'loading': isLoading }">
        Manage cards
      </a>
    </div>
  </div>
</div>
